<!-- notranslate - https://github.com/quilljs/quill/issues/2286 -->

<div
  preventPointSwitching
  #richTextComponentContainer
  notranslate
  class="richTextComponent__container"
  (ppOnRendered)="onRichTextRendered()"
  [class.richTextComponent__container--border]="
    ppRichTextOptions.defaultBorder &&
    (!activeQuill.editing || activeQuill.fieldId !== ppId) &&
    (ppCanEdit || !ppIsLocked)
  "
  [class.richTextComponent__container--defaultBorder]="
    !(ppRichTextOptions.defaultBorder && (!activeQuill.editing || activeQuill.fieldId !== ppId)) &&
    !ppRichTextOptions.comment
  "
  [class.richTextComponent__container--focused]="
    (focused || showingModal) && (ppCanEdit || !ppIsLocked)
  "
  [class.richTextComponent__container--disabled]="!showDefaultStyle || ppIsLocked"
  [class.richTextComponent__container--failed]="
    error || ppRichTextOptions.characterLimit - textLength < 0
  "
  [class.richTextComponent__container--blue]="showingBlueBorder && ppCanEdit && !ppIsLocked"
  [class.richTextComponent__container--field]="ppRichTextOptions.pointField"
  [class.richTextComponent__container--noBorder]="showDefaultStyle && (!ppCanEdit || ppIsLocked)"
  [class.richTextComponent__container--noPointerEvents]="
    ppRichTextOptions.processing && ppRichTextOptions.notification
  "
  [class.richText--comment]="ppRichTextOptions.comment"
  [class.richText--marginBottom]="ppRichTextOptions.showButtons && showDefaultStyle && editing"
  [class.richTextComponent__small]="
    ppRichTextOptions.small && (!activeQuill.editing || activeQuill.fieldId !== ppId)
  "
  [class.richTextComponent__notification]="ppRichTextOptions.notification"
  [class.richTextComponent__container--bulk]="ppRichTextOptions.bulkChanges"
  [class.richText--clearable]="ppRichTextOptions.clearable"
  [class.richText--hideToolbars]="!editing"
  ppTooltip
  [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null"
>
  <pp-spinner
    [ppInputTitle]="true"
    [ppHidden]="!ppRichTextOptions.processing || ppRichTextOptions.notification"
  />

  @if (
    ppRichTextOptions.success && !ppRichTextOptions.clearable && !ppRichTextOptions.notification
  ) {
    <i class="fas fa-check richTextComponent__saved-check" aria-hidden="true"></i>
  }

  <div>
    <div
      #richTextComponent
      preventPointSwitching
      (click)="!ppIsLocked ? activateRichText($event) : null"
    ></div>

    @if (ppIsLocked) {
      <div class="richTextComponent__lock">
        <pp-padlock-icon />
      </div>
    }
  </div>

  @if (
    !ppRichTextOptions.processing && ppRichTextOptions.clearable && !ppRichTextOptions.notification
  ) {
    <pp-save-indicator
      [ppFilled]="!!ppValue?.richText"
      [ppUpdating]="false"
      [ppShowClearBtn]="ppCanEdit && !ppIsLocked"
      (ppAction)="clearField()"
      [ppFocused]="activeQuill.editing && activeQuill.fieldId === ppId"
    />
  }

  <div
    #richTextComponentToolbar
    (click)="onToolbarClick($event)"
    class="richTextComponent__toolbar"
    [class.richTextComponent__toolbar--visible]="
      (ppCanEdit && !ppRichTextOptions.processing && !this.ppIsLocked) ||
      ppRichTextOptions.notification ||
      showingModal
    "
  >
    <button class="ql-bold"></button>
    <button class="ql-italic"></button>
    <button class="ql-underline"></button>
    <button class="ql-strike"></button>
    <button class="ql-link"></button>
    <button class="ql-list" value="ordered"></button>
    <button class="ql-list" value="bullet"></button>
    @if (ppEnableMentions) {
      <button type="button" class="mentionButton" (click)="showMentionsDropdown($event)">&#64;</button>
    }

    @if (ppRichTextOptions.characterLimit - textLength < 500) {
      <div
        class="richTextComponent__characterLimit"
        [class.richTextComponent__characterLimit--green]="
          ppRichTextOptions.characterLimit - textLength >= 0
        "
        [class.richTextComponent__characterLimit--red]="
          ppRichTextOptions.characterLimit - textLength < 0
        "
      >
        {{ textLength }} / {{ ppRichTextOptions.characterLimit }}
      </div>
    }
  </div>

  @if (ppRichTextOptions.showButtons && ppCanEdit && editing && !ppIsLocked) {
    <div class="description__actions telegramSendButton">
      <pp-button ppId="cancelDescriptionEditBtn" (ppAction)="cancel($event)" ppStyle="text">
        {{ 'cancel' | ppTranslate }}
      </pp-button>

      <pp-button
        ppStyle="primary"
        ppId="updateDescriptionBtn"
        (ppAction)="update(true)"
        [ppProcess]="ppRichTextOptions.processing"
      >
        {{ (ppRichTextOptions.notification ? 'comment' : 'update') | ppTranslate }}
      </pp-button>
    </div>
  }

  @if (
    ppRichTextOptions.notification && (ppRichTextOptions.processing || ppRichTextOptions.success)
  ) {
    <div class="richTextComponent__processing">
      @if (!ppRichTextOptions.success) {
        <div class="richText_spinner">
          <pp-spinner [ppNotification]="true"></pp-spinner>
        </div>
      } @else {
        <div class="richTextComponent__processing__sent">
          <img
            class="richTextComponent__processing__sent--img"
            [src]="EIconPath.NOTIFICATION_SENT_TICK"
          />

          {{ 'comment_sent' | ppTranslate }}
        </div>
      }
    </div>
  }
</div>
